import PropTypes from 'prop-types'

import rolePropType from './role-prop-types'

const userDetailsPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  email: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isDeleted: PropTypes.bool,
  roles: PropTypes.arrayOf(rolePropType.isRequired),
  permissions: PropTypes.arrayOf(PropTypes.string.isRequired),
  createdAt: PropTypes.string,
  lastLoginDate: PropTypes.string,
})

userDetailsPropType.defaultProps = {
  permissions: [],
  roles: [],
  name: undefined,
  createdAt: undefined,
  lastLoginDate: undefined,
  isActive: undefined,
  isDeleted: undefined,
}

export default userDetailsPropType
